import useAPI from '@/hooks/useAPI';
import useDebouncedValue from '@/hooks/useDebouncedValue';
import TreatmentGroupRepository from '@/repositories/TreatmentGroupRepository';
import { EligibilityLogicGroupPayload, MemberEligibilityCheckResult } from '@/types/treatmentGroup';

// Badges are informational only and must never block a save, so errors are
// suppressed and the query is disabled with no person ids -- there's nothing
// useful to show yet. Debouncing the whole criteria bundle (rather than each
// input separately) means a burst of edits to the query builder, the session
// staff, and the member list settles into a single request.
const useMemberEligibilityCheck = ({
  appointmentTypeId,
  eligibility,
  personIds,
  staffIds
}: {
  appointmentTypeId: string | null;
  eligibility: EligibilityLogicGroupPayload[];
  personIds: string[];
  staffIds: string[];
}) => {
  const treatmentGroupRepository = TreatmentGroupRepository();
  const debounced = useDebouncedValue({ appointmentTypeId, eligibility, personIds, staffIds });

  return useAPI<MemberEligibilityCheckResult>({
    enabled: debounced.personIds.length > 0 && !!debounced.appointmentTypeId,
    queryKey: ['treatmentGroupMemberEligibility', debounced],
    queryFn: () =>
      treatmentGroupRepository.checkMembers({
        appointment_type: debounced.appointmentTypeId as string,
        eligibility: debounced.eligibility,
        person_ids: debounced.personIds,
        staff_ids: debounced.staffIds
      }),
    supressErrorMessages: true
  });
};

export default useMemberEligibilityCheck;
